import React from "react";
import { Link } from "react-router-dom";
const Categories = () => {
  return (
    <div className="products sbg">
      <div className="Products-title-area">
        <div className="products-title">
          <h1>Kategoriler</h1>
        </div>
        <div className="products-title-button">
          <a href="/#">Kataloğu indir</a>
        </div>
      </div>
      <div className="product">
        <div className="products-area-s">
          <Link to={"/categories/s"}>
            <div className="product-single-s">
              <div className="product-single-image">
                <img
                  src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                  alt="product-1"
                />
              </div>
              <div className="product-single-alt">
                <p>ANTİOKSİDANLAR</p>
              </div>
            </div>
          </Link>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
          <div className="product-single-s">
            <div className="product-single-image">
              <img
                src="https://productimages.hepsiburada.net/s/28/375/10234378616882.jpg"
                alt="product-1"
              />
            </div>
            <div className="product-single-alt">
              <p>ANTİOKSİDANLAR</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Categories;
